import { useAuth } from "../../contexts/AuthContext";
import { PendingApprovalPage } from "../../pages/Auth/PendingApprovalPage";
import { AccountRejectedPage } from "../../pages/Auth/AccountRejectedPage";

export function ApprovalGuard({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  if (user?.status === "pending") {
    return <PendingApprovalPage />;
  }

  if (user?.status === "rejected") {
    return <AccountRejectedPage />;
  }

  return <>{children}</>;
}
